import * as CookieConsentPlugin from "@soenergy/frontend-library/src/services/CookieConsentPlugin"
export default () => {
  if (process.env.VUE_APP_USE_THIRD_PARTY_COOKIE_CONSENT === "true") {
    CookieConsentPlugin.init()
  }
}
